import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

export const isMigratedUserGuard: CanMatchFn = () => {
  const authorizationService = inject(AuthorizationService);
  const router = inject(Router);

  return authorizationService.isMigratedUser() || router.createUrlTree([TopNavigationPath.Home]);
};
